<template>
  <div class="col-sm-12 nopads pt-2">
        <div class="col-sm-12 nopads">
          <work-defect-search @search="fetchDefects"/>
          <work-defect-list :items="results" @edit="editDefect"/>
          <base-modal v-if="editMode" hide-header hide-footer @close="showList" size="lg">
                <work-defect-editor
                    v-if="editMode"
                    :defect="defect"
                    :is-observer="isObserver"
                    @close="showList"
                    @close-and-update="closeAndUpdate"
                />
          </base-modal>
          <div
            v-if="loading"
            id="loader"
            class="spinner"
          />
        </div>
  </div>
</template>

<script>
import {restApi} from '../../mixins/RestApiMixin'
import BaseModal from "@/components/BaseModal";
import WorkDefectSearch from "@/components/inspections/workdefects/WorkDefectSearch";
import WorkDefectList from "@/components/inspections/workdefects/WorkDefectList";
import WorkDefectEditor from "@/components/inspections/workdefects/WorkDefectEditor";

export default {
    name: 'WorkDefects',
    components: {
        WorkDefectEditor,
        WorkDefectList,
        WorkDefectSearch,
        BaseModal
    },
    mixins: [restApi],
    props: {
        isObserver: {
            type: Boolean,
            default: null
        },
        vehicle: {
            type: Object,
            default: null
        },
        items: {
            type: Array,
            default() {
                return []
            }
        }
    },
    data: function () {
        return {
            results: [],
            defect: null,
            editMode: false,
            loading: false,
            vehicles: [],
            lastSearchedParams: null
        }
    },
    watch: {
        items() {
            this.results = this.items
        },
    },
    methods: {
        fetchDefects: function (params) {
            this.loading = true
            this.lastSearchedParams = params
            this.results = []
            this.restFetchParams(this.workDefectUrl, this.lastSearchedParams, this.handleResponse)
        },

        handleResponse: function (response) {
            this.results = response && response.data ? response.data : []
            this.loading = false
        },

        editDefect: function (defect) {
            this.defect = defect
            this.editMode = true
        },

        showList: function () {
            this.editMode = false
        },

        closeAndUpdate: function () {
            this.showList()
            this.fetchDefects(this.lastSearchedParams)
        }
    }
}
</script>

<style scoped>

</style>
